// Explore-stats page: Aboriginal and/or Torres Strait Islander
// Parliamentarians. Recreates the Handbook page — service timeline plus
// breakdowns by party, state/territory and Parliament.

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import GanttTimeline from './GanttTimeline';
import { StatBar } from './charts';

export default function FirstNations() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('first-nations');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Aboriginal and/or Torres Strait Islander Parliamentarians"
      description={`Aboriginal and/or Torres Strait Islander parliamentarians${
        charts.total ? ` (${charts.total})` : ''
      } — the first elected, a notable gap with no Indigenous representation, and the increase in recent Parliaments.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="first-nations-parliamentarians"
    >
      {data && (
        <>
          <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Aboriginal and/or Torres Strait Islander Parliamentarians
            </Typography>
            <GanttTimeline items={charts.timeline || []} rowHeight={20} />
          </Paper>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>By party</Typography>
                <StatBar data={charts.by_party || []} xKey="party" yKey="count"
                         layout="vertical" height={300} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>By state/territory</Typography>
                <StatBar data={charts.by_state || []} xKey="state" yKey="count"
                         layout="vertical" height={300} />
              </Paper>
            </Grid>
          </Grid>
          <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>By Parliament</Typography>
            <StatBar data={charts.by_parliament || []} xKey="parliament"
                     yKey="count" />
          </Paper>
        </>
      )}
    </ExploreStatsPage>
  );
}
